export enum VerticalAlign {

  BOTTOM = 'text-bottom',
  MIDDLE = 'middle',
  TOP = 'text-top'

}